<template>
    <div>
        <b-form-group :label="`${$t('form.label.isCalculatedAutomatically')}*`" label-for="calculation">
            <c-select
                id="calculation"
                :state="state"
                :selected="isCalculated"
                :options="calculationOptions"
                @changeValue="onChangeCalculation"
                aria-describedby="calculationFeedback"
                :disabled="disabled"
            />
            <b-form-invalid-feedback id="calculationFeedback">
                <slot />
            </b-form-invalid-feedback>
        </b-form-group>
        <b-collapse v-model="showNewFormula" id="newFormula">
            <b-card>
                <b-form-group :label="`${$t('form.label.calculateBy')}*`" label-for="use-progress-on-automatic-checkin">
                    <c-select
                        id="use-progress-on-automatic-checkin"
                        :state="stateUseProgressOnAutomaticCheckin"
                        :selected="useProgressOnAutomaticCheckin"
                        :options="checkinTypeOptions"
                        @changeValue="onChangeUseProgressOnAutomaticCheckin"
                        aria-describedby="calculateByFeedback"
                        :disabled="disabled"
                    />
                    <b-form-invalid-feedback id="CalculateByFeedback">
                        <slot />
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group :label="`${$t('form.label.formula')}*`" :description="$t('form.description.formula')">
                    <formula
                        id="rawFormula"
                        :state="rawFormulaState"
                        :contentHtml="formulaHtml"
                        @changeValue="onChangeRawFormula"
                        :placeholder="`${$t('form.placeholder.formula')}\n${$t('form.description.formula')}\n${$t(
                            'form.placeholder.formulaAllowedChars'
                        )}\n${$t('form.placeholder.formulaExemple')}`"
                        :disabled="disabled"
                        :is-kpi-available="isKpiAvailable"
                        :is-goal-available="isGoalAvailable"
                        :indicator-id="indicatorId"
                        :periods="periods"
                    />
                    <b-form-input
                        id="formula"
                        :state="stateFormula"
                        :value="formula"
                        @input="emitChangeFormula($event)"
                        class="d-none"
                    />
                    <b-form-input
                        id="formulaHtml"
                        :state="stateFormulaHtml"
                        :value="formulaHtml"
                        @input="emitChangeFormulaHtml($event)"
                        class="d-none"
                    />
                </b-form-group>
            </b-card>
        </b-collapse>
    </div>
</template>

<script>
import { Select as CSelect } from '@/views/components/selects'
import defaultIsCalculatedOptions from '@/data/calculation'
import defaultIsCalculatedCheckinTypeOptions from '@/data/calculation-checkin-type-options'
import Formula from '@/views/components/formula'
import api from '@/services/api'

export default {
    name: 'Calculation',
    components: {
        CSelect,
        Formula,
    },
    props: [
        'isCalculated',
        'useProgressOnAutomaticCheckin',
        'formula',
        'formulaHtml',
        'state',
        'stateUseProgressOnAutomaticCheckin',
        'stateFormula',
        'stateFormulaHtml',
        'disabled',
        'isKpiAvailable',
        'isGoalAvailable',
        'indicatorId',
    ],
    data() {
        return {
            newFormula: '1',
            showNewFormula: false,
            calculationOptions: defaultIsCalculatedOptions,
            checkinTypeOptions: defaultIsCalculatedCheckinTypeOptions,
            periods: [],
        }
    },
    mounted() {
        this.handlePeriods()
    },
    computed: {
        rawFormulaState() {
            return this.stateFormula && this.stateFormulaHtml
        },
    },
    watch: {
        isCalculated(newValue, oldValue) {
            if (newValue != oldValue) {
                const { value } = newValue
                this.showNewFormula = !!(value != 0)
            }
        },
    },
    methods: {
        async handlePeriods() {
            let periods = await this.getPeriods()
            this.periods = periods
                .filter((period) => ['in_progress', 'in_draft'].includes(period.status))
                .map((period) => {
                    return period.id
                })
        },
        getPeriods() {
            return api
                .get('/periods', {
                    params: {
                        scopes: 'notArchived',
                    },
                })
                .then((resp) => {
                    return resp.data.data
                })
                .catch((e) => {
                    console.log(e)
                })
                .finally(() => {
                    this.$emit('ready', true)
                })
        },
        emitChangeFormula(value) {
            this.$emit('update:formula', value)
        },
        emitChangeFormulaHtml(value) {
            this.$emit('update:formulaHtml', value)
        },
        onChangeCalculation(values) {
            const currentValue = values && values.value
            this.addFormula(currentValue)
            this.$emit('update:isCalculated', values)
        },
        onChangeUseProgressOnAutomaticCheckin(values) {
            this.$emit('update:useProgressOnAutomaticCheckin', values)
        },
        onChangeRawFormula(html, formula) {
            this.emitChangeFormula(formula)
            this.emitChangeFormulaHtml(html)
        },
        addFormula(event) {
            this.showNewFormula = event === this.newFormula
        },
    },
}
</script>
